import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { ApiServices } from '../shared/services/api.services';
import { ApiConstants } from '../shared/constants/api.constants';
import { CookieService } from '../shared/services/cookie.service';

@Injectable()
export class AuthService {
  private _isLoggedIn: boolean;

  // store the URL so we can redirect after logging in
  isCustomURL: boolean;
  customRedirectURL: any;
  sessionInfo: any;

  constructor(
    private router: Router,
    private apiService: ApiServices,
    private apiConstants: ApiConstants,
    private cookieService: CookieService,
    private location: Location) {
    this.isCustomURL = false;
    this._isLoggedIn = false;
  }


  logout() {
    this._isLoggedIn = false;
    let invalidSession = sessionStorage.getItem('invalidSession');

    const logoutCleanUp = () => {
      if (invalidSession === 'false') {
        this.cookieService.deleteCookie('bxbd-activeUrl');
      }
      this.goToLogin();
    };

    this._isLoggedIn = false;
    this.inValidateSession(_ => logoutCleanUp(), _ => logoutCleanUp());
  }

  goToLogin() {
    this.router.navigate(['/login']);
  }

  inValidateSession(success: (data: Object) => void, error: (data: Object) => void) {

    let header = {};
    this.apiService.serviceCall(
      this.apiConstants.authUrl.logout.url,
      this.apiConstants.authUrl.logout.method,
      null,
      null,
      header
    ).subscribe(data => success(data), err => error(err));

    this.logoutOkta();
  }

  logoutOkta() {
    this.apiService.serviceCall(
      this.apiConstants.authUrl.oktaLogout.url + '/api/v1/sessions/me',
      this.apiConstants.authUrl.oktaLogout.method,
      null,
      null,
      {}
    ).subscribe(() => {
      this.goToLogin();
    }, () => {
      this.goToLogin();
    });

  }

  handleInActiveSession() {
    this.isCustomURL = true;
    let currentPath = this.getCurrentActivePath();
    this.customRedirectURL = currentPath;
    this.logout();
  }

  gotoHome() {
    let redirect = window.location.protocol + '//' + window.location.hostname + '/home';
    if (window.location.hostname === 'localhost' || window.location.hostname === 'local.bxbdigital.com') {
      redirect = window.location.protocol + '//' + window.location.hostname + ':4026/';
    }
    window.location.href = redirect;
  }

  gotoUserPreferredApp(path, subPath?, qParams?) {
    const domain = this.getCurrentDomain();
    window.location.href = qParams && subPath ? `${domain}/${path}/#/${subPath}?${qParams}`
                            : subPath ? `${domain}/${path}/#/${subPath}` : `${domain}/${path}`;
  }
  getCurrentDomain() {
    return window.location.protocol + '//' + window.location.hostname;
  }

  setSession(sessionInfo) {
    this._isLoggedIn = true;
    this.sessionInfo = sessionInfo;
  }

  navigate() {
    this.getCurrentActivePath();
    if (this._isLoggedIn && !this.isCustomURL) {
      this.router.navigate(['/login/tenant']);
    } else if (this.isCustomURL) {
      window.location.href = this.customRedirectURL;
    }
  }

  validateSession() {
    let header = {};
    return this.apiService.serviceCall(
      this.apiConstants.authUrl.validate.url,
      this.apiConstants.authUrl.validate.method,
      null,
      null,
      header
    );
  }

  getTenants() {
    return this.apiService.serviceCall(
        this.apiConstants.authUrl.getTenants.url,
        this.apiConstants.authUrl.getTenants.method,
        null,
        null,
        {}
    );
  }

  updateTenant(tenant) {
    return this.apiService.serviceCall(
      this.apiConstants.authUrl.updateTenant.url,
      this.apiConstants.authUrl.updateTenant.method,
        tenant,
        null,
        {}
    );
  }

  getUserPreference(preferenceName) {
    const url = `${this.apiConstants.authUrl.getUserPreference.url}/${preferenceName}`;
    return this.apiService.serviceCall(
      url,
      this.apiConstants.authUrl.getUserPreference.method,
      null,
      null,
      {}
    );
  }

  logoutUser() {
    return this.apiService.serviceCall(
      this.apiConstants.authUrl.logout.url,
      this.apiConstants.authUrl.logout.method,
      null,
      null,
      {}
    );
  }

  get isLoggedIn() {
    return this._isLoggedIn;
  }

  getCurrentActivePath() { // not good method both set and get
    let url = this.location.path();
    let getUrl = this.cookieService.getCookie('bxbd-activeUrl');
    if (getUrl !== null) {
      this.isCustomURL = true;
      url = getUrl;
      this.customRedirectURL = url;
    }
    this.cookieService.deleteCookie('bxbd-activeUrl');
    return url;
  }

  // BRIX-8197: Fix for 302 redirect
  validateRedirectUrl( url: string ) {
    if ( url && url.split('#/render')[1]) {
      let redirectUrl;
      if (window.location.hostname === 'localhost' || window.location.hostname === 'local.bxbdigital.com') {
        redirectUrl = window.location.protocol + '//' + window.location.hostname + ':6552/' + url.split('/login')[1];
      } else {
        const isStudioUrl = url.includes('studioUrl');
        const appName = isStudioUrl ? '/studio/' : '/apps1/';
        redirectUrl = this.apiConstants.baseUrl + appName + url.split('/login')[1];
        this.setRedirectPath( redirectUrl);
      }
    }
  }

  setRedirectPath( url) {
    if ( url) {
      this.cookieService.createCookie('bxbd-activeUrl', url, 1);
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/auth/auth.service.ts